<template>
  <div class="page">
    <div class="container">
      <div class="item" v-for="item in list2" :key="item.id">

        <!-- 左侧（3份） -->
        <div class="box">
          <h3>{{ item.name }}</h3>

          <p>{{ item.content }}</p>

          <!-- 单下载 -->
          <a
            v-if="item.a && item.id != '03'"
            class="down"
            :href="link"
            target="_blank"
          >
            下载
          </a>

          <!-- 双下载 -->
          <div v-if="item.id == '03'" class="multi-down">
            <a class="down" :href="link2" target="_blank">Mac</a>
            <a class="down" :href="link" target="_blank">Windows</a>
          </div>
        </div>

        <!-- 右侧（7份） -->
        <div class="plug-img-wrap">
          <img :src="item.imgUrl" alt="" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { getDownload } from "../../../api/home/index";

export default {
  data() {
    return {
      list: [
        {
          id: "01",
          imgUrl: require("../../../assets/mock/browser/图像 93@2x.png"),
          content:
            "宇起智能密码器设备专用浏览器插件，支持指纹快速登录功能",
          name: "宇起谷歌浏览器插件",
          a: true,
        },
        {
          id: "02",
          imgUrl: require("../../../assets/mock/browser/图像 93@2x.png"),
          content: "请前往宇起客户端安装对应浏览器插件",
          name: "宇起火狐浏览器插件",
        },
        {
          id: "03",
          imgUrl: require("../../../assets/mock/browser/图像 93@2x.png"),
          content:
            "智能指纹密码器专用电脑客户端，用于指纹登录电脑与应用",
          name: "宇起助手",
          a: true,
        },
        {
          id: "04",
          imgUrl: require("../../../assets/mock/browser/图像 93@2x.png"),
          content: "请前往宇起客户端安装对应浏览器插件",
          name: "宇起Edge浏览器插件",
        },
        {
          id: "05",
          imgUrl: require("../../../assets/mock/browser/图像 93@2x.png"),
          content: "请前往宇起客户端安装对应浏览器插件",
          name: "宇起360浏览器插件",
        },
      ],

      list2: [],
      id: "",
      link: "",
      link2: "",
    };
  },

  watch: {
    $route: {
      handler(newRoute) {
        if (newRoute.query.id) {
          this.id = newRoute.query.id;
          this.getList();
          this.getDown();
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.id = this.$route.query.id;
    this.getList();
    this.getDown();
    this.getDown2();
  },

  methods: {
    getList() {
      this.list2 = this.list.filter((obj) => obj.id == this.id);
    },

    getDown() {
      if (!this.id) return;

      let type = "";

      if (this.id == "01") type = "101";
      else if (this.id == "02") type = "102";
      else if (this.id == "04") type = "103";
      else if (this.id == "03") type = "201";

      if (!type) return;

      getDownload(type).then((res) => {
        this.link = res.data.data.link;
      });
    },

    getDown2() {
      getDownload("202").then((res) => {
        this.link2 = res.data.data.link;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  min-height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center; /* ⭐上下居中关键 */
  font-family: PingFangSC, PingFang SC;
  padding: 2rem 0;
}

.container {
  width: 85%;
  max-width: 1200px;
}

/* ===== 4:6 布局 ===== */
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 3rem;
}

/* ===== 左侧 40%（文字更大） ===== */
.box {
  flex: 4;
  min-width: 0;

  h3 {
    font-size: clamp(32px, 2.4vw, 34px); /* ⭐放大标题 */
    font-weight: 700;
    color: #333;
    margin: 0;
  }

  p {
    font-size: clamp(24px, 1.4vw, 18px); /* ⭐放大正文 */
    color: #333;
    margin: 1.5rem 0;
    line-height: 1.8;
    font-family: PingFangSC, PingFang SC;
  }
}

/* ===== 右侧 60% ===== */
.plug-img-wrap {
  flex: 6;
  display: flex;
  justify-content: center;
  align-items: center;
}

.plug-img-wrap img {
  width: 100%;
  max-width: 700px; /* ⭐比之前更大 */
  height: auto;
  object-fit: contain;
  display: block;
}

/* ===== 按钮 ===== */
.down {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  font-size: 24px;
  padding: 10px 32px;

  background-color: #ebcc26;
  color: #fff;
  border-radius: 8px;
  text-decoration: none;

  margin-right: 12px;
  transition: 0.2s;
}

.down:hover {
  transform: translateY(-2px);
  opacity: 0.9;
}

.multi-down {
  display: flex;
  gap: 12px;
}

/* ===== 手机适配 ===== */
@media (max-width: 768px) {
  .item {
    flex-direction: column;
    align-items: flex-start;
  }

  .box,
  .plug-img-wrap {
    flex: unset;
    width: 100%;
  }

  .plug-img-wrap {
    margin-top: 1.5rem;
  }
}
</style>